var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { uuidv4, XFlowNodeCommands } from '@antv/xflow';
import { getProps, onConfigChange } from '../../../util';
/** 节点查找 */
export var searchService = function (treeNodeList, keyword) {
    if (treeNodeList === void 0) { treeNodeList = []; }
    return __awaiter(void 0, void 0, void 0, function () {
        var list;
        return __generator(this, function (_a) {
            list = treeNodeList.filter(function (i) { var _a, _b; return i.isDirectory || ((_a = i.label) === null || _a === void 0 ? void 0 : _a.includes(keyword)) || ((_b = i.name) === null || _b === void 0 ? void 0 : _b.includes(keyword)); });
            return [2 /*return*/, list];
        });
    });
};
export var onNodeDrop = function (node, commands) { return __awaiter(void 0, void 0, void 0, function () {
    var ports, flowchartId, nodeConfig, args, onAddNode;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                ports = node.ports, flowchartId = node.flowchartId;
                nodeConfig = __assign(__assign({}, node), { id: "node-".concat(uuidv4()), zIndex: 10, ports: __assign(__assign({}, ports), { 
                        // @ts-ignore
                        items: (_a = ports.items) === null || _a === void 0 ? void 0 : _a.map(function (item) { return (__assign(__assign({}, item), { id: uuidv4() })); }) }) });
                args = {
                    nodeConfig: nodeConfig,
                };
                return [4 /*yield*/, commands.executeCommand(XFlowNodeCommands.ADD_NODE.id, args)];
            case 1:
                _b.sent();
                onAddNode = getProps(flowchartId, 'onAddNode');
                if (typeof onAddNode === 'function') {
                    onAddNode(nodeConfig);
                }
                onConfigChange({ type: 'add:node', config: nodeConfig });
                return [2 /*return*/];
        }
    });
}); };
